import { ToastService } from 'src/app/base/services/toast.service';
import { Component, ViewChild, TemplateRef, Input } from '@angular/core';
import { ToastComponent as SyncfusionToastComponent, ToastModule } from '@syncfusion/ej2-angular-notifications';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf, NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-toast',
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.scss'],
    standalone: true,
    imports: [ToastModule, NgIf, NgTemplateOutlet, TranslateModule]
})
export class ToastComponent {

  @Input() public toast: any;
  @Input() public index: number;
  @ViewChild(SyncfusionToastComponent) public toastElement: SyncfusionToastComponent;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  public position = { X: 'Right', Y: 'Top' };

  constructor(public toastService: ToastService) { }

  public isTemplate(toast: any) {
    return toast.textOrTpl instanceof TemplateRef;
  }

  public onCreate(): void {
    this.toastElement.show({timeOut: this.toast.delay || 5000, cssClass: this.toast.classname});
  }

  public closeToast(event: any): void {
    event.clickToClose = true;
  }

}
